<!-- <h2 mat-dialog-title>Install Angular</h2> -->
<div mat-dialog-content class="mat-typography">
  <iframe
    *ngIf="type=='vedio'"
    width="560"
    height="315"
    [src]="link | safeUrl"
    frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen
  ></iframe>
  <img
    *ngIf="type=='image'"
    src="assets/event/gallery/{{name}}"
    class="img-fluid"
  />
</div>
<div mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Close</button>
  <!-- <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Install</button> -->
</div>

<!-- Copyright 2020 Google LLC. All Rights Reserved.
    Use of this source code is governed by an MIT-style license that
    can be found in the LICENSE file at http://angular.io/license -->
